<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">面料类别</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1">
            <div class="label">面料分类名：</div>
            <label
              ><input type="text" class="cg-input" v-model="flname"
            /></label>
          </div>
          <div class="item col-1">
            <div class="form-options">
              <el-button size="small" class="custom-btn" @click="add"
                >新增</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table
      :data="list"
      height="500px"
      border
      style="width: 100%"
      class="custom-table"
    >
      <el-table-column align="center" prop="name" label="面料分类名" />
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <div class="options">
            <i
              class="update-icon el-icon-edit"
              title="修改"
              @click="up(scope.row)"
            ></i>
            <el-popconfirm
              title="确认删除吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="delUser(scope.row.id)"
            >
              <template #reference>
                <i class="del-icon el-icon-close" title="删除"></i>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="修改" center width="366px" v-model="dialogTableVisible">
      <div class="update-view">
        <div class="item">
          <span class="label">面料类别：</span>
          <label
            ><input
              style="margin-left: 15px"
              type="text"
              class="cg-input"
              v-model="upflname"
          /></label>
        </div>
        <div class="footer">
          <el-button class="custom-btn" size="small" @click="save"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, watch } from "vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";

const store = useStore();
const { proxy } = getCurrentInstance();
const $api = proxy.$api;

const flname = ref("");
const list = ref([]);
const userid = ref("");
const dialogTableVisible = ref(false);
const upflname = ref("");
const upid = ref("");

// 缓存值
const STORAGE_KEY = "/publish-clothes/basicData/productFabricCategory";

// 监听查询条件
watch([flname], () => {
  const searchParams = {
    flname: flname.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);

      flname.value = cache.flname ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

// 获取列表
const getlist = async () => {
  const res = await $api.BasicData.get(userid.value);
  console.log(res.data.code);
  if (res.data.code == 200) {
    list.value = res.data.data.list;
    console.log(list.value, "返回的列表是什么格式");
  } else {
    ElMessage.error("网络错误");
    list.value = [];
  }
};

// 删除
const delUser = async (id) => {
  const sendata = { id: id };
  const res = await $api.BasicData.del(sendata);
  if (res.data.code == 200) {
    ElMessage.success("删除成功");
    getlist();
  } else {
    ElMessage.error("网络错误");
  }
};

// 新增
const add = async () => {
  if (flname.value == "") {
    ElMessage.warning("添加的分类名不能为空");
    return;
  }
  const sendata = {
    name: flname.value,
  };
  console.log(sendata, "看看参数是否正确");
  const res = await $api.BasicData.add(sendata);
  if (res.data.code == 200) {
    flname.value = "";
    ElMessage.success("新增成功");
    getlist();
  } else {
    ElMessage.error("网络错误");
  }
};

// 打开修改弹窗
const up = async (row) => {
  upid.value = "";
  upflname.value = "";
  upflname.value = row.name;
  upid.value = row.id;
  dialogTableVisible.value = true;
};

// 保存修改
const save = async () => {
  const sendata = {
    id: upid.value, //id
    name: upflname.value, //面料类别名
  };
  console.log("参数是否正确", sendata);
  try {
    const res = await $api.BasicData.updata(sendata);
    if (res.data.code == 200) {
      dialogTableVisible.value = false;
      ElMessage.success("修改成功");
      getlist();
    } else {
      ElMessage.error("修改失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    ElMessage.error("网络错误，修改失败");
  }
};

onMounted(async () => {
  userid.value = store.state.frontUserInfo.id;
  loadSearchCache();
  await getlist();
});
</script>

<style lang="scss" scoped>
@import "./productFabricCategory.scss";
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
:deep(.el-dialog) {
  margin-top: 25vh !important;
}
:deep(.el-dialog--center .el-dialog__body) {
  height: 120px !important;
}
.main-panel.large {
  background-color: #fff;
}
.panel-title {
  color: #666;
}
:deep(.el-select .el-input__inner) {
  background-color: #fff;
}
:deep(.el-select .el-input__inner:focus) {
  background-color: #fff;
}
:deep(.custom-table) {
  background-color: #fff !important;
  .el-table__header-wrapper {
    background-color: #fff !important;
    .el-table__header {
      background-color: #fff !important;
      th {
        background-color: #fff !important;
      }
    }
  }
  .el-table__body-wrapper {
    background-color: #fff !important;
    .el-table__body {
      background-color: #fff !important;
      td {
        background-color: #fff !important;
      }
    }
  }
}
:deep(.el-dialog--center) {
  background-color: #fff !important;
}
</style>
